module.exports = __webpack_public_path__ + "img/italy.65e812ff.jpg";